import { Route } from '@angular/router';
import { biLandingRoute } from './bi-route.helpers';

export const BI_LANDING_ROUTES: Route[] = [
  biLandingRoute({
    path: 'dashboard/dashboard/dashboard',
    moduleId: 'dashboard',
    activeMenubarId: 'dashboard-landing',
    title: 'Panel de control',
    breadcrumbs: [
      { id: 'dashboard', label: 'Panel de control' },
      { id: 'dashboard-landing', label: 'Panel de control' },
    ],
    loadComponent: () =>
      import('../pages/dashboard/dashboard/dashboard/dashboard.component').then(
        m => m.DashboardLandingComponent,
      ),
  }),
  biLandingRoute({
    path: 'commercial/commercial/commercial',
    moduleId: 'commercial',
    activeMenubarId: 'commercial-landing',
    title: 'Comercial',
    breadcrumbs: [
      { id: 'commercial', label: 'Comercial' },
      { id: 'commercial-landing', label: 'Comercial' },
    ],
    loadComponent: () =>
      import(
        '../pages/commercial/commercial/commercial/commercial.component'
      ).then(m => m.CommercialLandingComponent),
  }),
  biLandingRoute({
    path: 'treasury/treasury/treasury',
    moduleId: 'treasury',
    activeMenubarId: 'treasury-landing',
    title: 'Tesorería',
    breadcrumbs: [
      { id: 'treasury', label: 'Tesorería' },
      { id: 'treasury-landing', label: 'Tesorería' },
    ],
    loadComponent: () =>
      import('../pages/treasury/treasury/treasury/treasury.component').then(
        m => m.TreasuryLandingComponent,
      ),
  }),
  biLandingRoute({
    path: 'construction/construction/construction',
    moduleId: 'construction',
    activeMenubarId: 'construction-landing',
    title: 'Control de obra',
    breadcrumbs: [
      { id: 'construction', label: 'Control de obra' },
      { id: 'construction-landing', label: 'Control de obra' },
    ],
    loadComponent: () =>
      import(
        '../pages/construction/construction/construction/construction.component'
      ).then(m => m.ConstructionLandingComponent),
  }),
  biLandingRoute({
    path: 'accounting/accounting/accounting',
    moduleId: 'accounting',
    activeMenubarId: 'accounting-landing',
    title: 'Contabilidad',
    breadcrumbs: [
      { id: 'accounting', label: 'Contabilidad' },
      { id: 'accounting-landing', label: 'Contabilidad' },
    ],
    loadComponent: () =>
      import(
        '../pages/accounting/accounting/accounting/accounting.component'
      ).then(m => m.AccountingLandingComponent),
  }),
  biLandingRoute({
    path: 'audit/audit/audit',
    moduleId: 'audit',
    activeMenubarId: 'audit-landing',
    title: 'Auditoría',
    breadcrumbs: [
      { id: 'audit', label: 'Auditoría' },
      { id: 'audit-landing', label: 'Auditoría' },
    ],
    loadComponent: () =>
      import('../pages/audit/audit/audit/audit.component').then(
        m => m.AuditLandingComponent,
      ),
  }),
];
